import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { tokens } from 'styling/tokens'
import { groputDashboardItems } from 'utils/helpers'
import { GLWidget } from './GLWidget'

const META = [
  { label: 'Not Started', color: tokens.text.muted },
  { label: 'In Progress', color: tokens.status.info.fg },
  { label: 'Completed', color: tokens.status.success.fg },
  { label: 'Idle', color: tokens.status.warning.fg },
  { label: 'Paused', color: tokens.accent.base },
]

export const GLTasksWidget = () => {
  const { taskStatuses } = useSelector((state: RootState) => state.dashboard)
  const tasksData = groputDashboardItems(taskStatuses)
  const getTaskStatus = (name: string): number => Number(tasksData?.find((td) => td.name == name)?.value) || 0

  const values = META.map((m) => ({ ...m, value: getTaskStatus(m.label) }))
  const total = values.reduce((s, r) => s + r.value, 0)
  const rows = values.map((m) => ({
    key: m.label,
    label: m.label,
    value: m.value,
    pct: total ? Math.round((m.value / total) * 100) : 0,
    color: m.color,
  }))

  return <GLWidget title='Tasks' rows={rows} />
}
